import { Option } from "../../../components/reusable-components/form/FormAutocomplete";
import { Product } from "./Product";
import {
  WithSettings,
  WithSettingsConstructor,
} from "../../setting/models/WithSettings";

export interface ProductCreateConstructor
  extends Omit<
      Product,
      "id" | "domain" | "category" | "category_id" | "domain_id" | "settings"
    >,
    WithSettingsConstructor {
  domain_id: Option;
  category_id: Option;
}

export class ProductCreate
  extends WithSettings
  implements Omit<Product, "id" | "domain" | "category">
{
  public readonly name: string;
  public readonly slug: string;
  public readonly short_description?: string;
  public readonly description?: string;
  public readonly price: number;
  public readonly sale_price?: number | null;
  public readonly domain_id: string;
  public readonly category_id: string;
  public readonly image_url?: string;
  public readonly brand_name?: string;
  public readonly stock_quantity: number;
  public readonly rating?: number;
  public readonly affiliate_link?: string;

  constructor(props: ProductCreateConstructor) {
    super(props);
    this.name = props.name;
    this.slug = props.slug;
    this.short_description = props.short_description;
    this.description = props.description;
    this.price = props.price;
    this.sale_price = props.sale_price;
    this.domain_id = props.domain_id.value;
    this.category_id = props.category_id.value;
    this.image_url = props.image_url;
    this.brand_name = props.brand_name;
    this.stock_quantity = props.stock_quantity;
    this.rating = props.rating;
    this.affiliate_link = props.affiliate_link;
  }
}
